import React from 'react'
import styled from 'styled-components'
import Spacer from '../../lib/spacer'
import StoreLinks from '../../common/store_links'
import AppShowcase from '../../common/app_showcase'
import { useTranslation } from '../../lib/i18n'

const Wrapper = styled.div``

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'home.getToday' })

    return (
        <Wrapper>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={50} className="show-for-small-only" />
            <div className="main grid-container">
                <div className="grid-x align-center">
                    <div className="cell small-12 medium-8 large-6">
                        <AppShowcase />
                        <Spacer size={50} />
                    </div>
                    <div className="cell medium-12 text-center">
                        <h2>{t('heading')}</h2>
                        <p className="lead">{t('lead')}</p>
                        <Spacer size={50} />
                        <div className="grid-x align-center">
                            <StoreLinks />
                        </div>
                    </div>
                </div>
            </div>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={70} className="show-for-small-only" />
        </Wrapper>
    )
}
